import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";

/*
 * @Author: lijianzhang
 * @Date: 2019-02-18 17:40:00
 * @Last Modified by: 天吾
 * @Last Modified time: 2019-10-09 14:08:15
 * 将vue组建建改成Promise方法渲染的形式
 */
import Vue from 'vue';
export default function createDialog(component) {
  var rootVm = null;

  component.open = function (data) {
    if (data === void 0) {
      data = {};
    }

    var _data = data,
        on = _data.on,
        onOk = _data.onOk,
        onCancel = _data.onCancel,
        afterClose = _data.afterClose,
        parent = _data.parent,
        router = _data.router,
        ref = _data.ref,
        other = _objectWithoutPropertiesLoose(_data, ["on", "onOk", "onCancel", "afterClose", "parent", "router", "ref"]);

    var VueComponent = Vue.extend(component);
    var dialogVm = new VueComponent({
      parent,
      router,
      propsData: other
    });
    rootVm = dialogVm;

    if (on) {
      Object.keys(on).forEach(function (key) {
        rootVm.$on(key, on[key]);
      });
    }

    rootVm.$mount();

    if (ref) {
      ref.vm = rootVm;
    }

    if (component.name !== 'g-dialog') {
      var vm = rootVm.$children[0];

      if (vm.$options.name === 'g-dialog') {
        dialogVm = vm;
      } else {
        throw new Error('根组件必须是dialog');
      }
    }

    dialogVm.innerVisible = true;
    var done = false;

    rootVm.update = function (data) {
      if (data === void 0) {
        data = {};
      }

      Object.assign(rootVm, data);
    };

    return new Promise(function (resolve) {
      rootVm.$close = function () {
        dialogVm.innerVisible = false;
        resolve(false);
      };

      rootVm.$onOk = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
          var res;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!onOk) {
                    _context.next = 6;
                    break;
                  }

                  _context.next = 3;
                  return onOk(data);

                case 3:
                  res = _context.sent;

                  if (!(res === false)) {
                    _context.next = 6;
                    break;
                  }

                  return _context.abrupt("return");

                case 6:
                  done = true;
                  dialogVm.innerVisible = false;
                  resolve(data || true);

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();

      rootVm.$onCancel = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!onCancel) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 3;
                return onCancel();

              case 3:
                res = _context2.sent;

                if (!(res === false)) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return");

              case 6:
                done = true;
                dialogVm.innerVisible = false;
                resolve(false);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      if (dialogVm !== rootVm) {
        dialogVm.$close = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  rootVm.$close();

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        dialogVm.$onOk = /*#__PURE__*/function () {
          var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(data) {
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    rootVm.$onOk(data);

                  case 1:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));

          return function (_x2) {
            return _ref4.apply(this, arguments);
          };
        }();

        dialogVm.$onCancel = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  rootVm.$onCancel();

                case 1:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        dialogVm.$afterClose = function () {
          if (afterClose) afterClose();
          if (done) rootVm.$destroy();
        };
      }
    }).then(function (v) {
      if (!dialogVm.innerVisible) rootVm.$destroy();
      dialogVm.innerVisible = false;
      return v;
    });
  };

  component.close = function () {
    rootVm && rootVm.$close();
  };

  return component;
}